module.exports = __webpack_public_path__ + "static/img/09.805d711.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/09.jpg
// module id = x4EV
// module chunks = 6